import { LayoutFormProps } from "./layout-form.type";
import * as SC from "./layout-form.style";
import { Button, Typography } from "@mui/material";
import React from "react";
import { BackButton } from "lib/components/ui";

export const LayoutForm = ({
  formTitle,
  children,
  handleSubmit,
  disabledSubmit,
  backUrl,
}: LayoutFormProps) => {
  return (
    <SC.LayoutForm>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <BackButton to={backUrl}>
          <Typography className="page-title" variant="h5">
            {formTitle}
          </Typography>
        </BackButton>
        <div className="form-fields">{children}</div>
        <br />
        <Button
          disabled={disabledSubmit || false}
          variant="contained"
          color="primary"
          type="submit"
          className="submit-button"
        >
          ثبت
        </Button>
      </form>
    </SC.LayoutForm>
  );
};
